import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  adminRoot: {
    padding: theme.spacing(4),
    margin: theme.spacing(4, 4, 6, 4),
    background: 'white',
  },
  actionsAdminFooter: {
    display: 'flex',
  },
  cancelButton: {
    paddingRight: theme.spacing(2),
  },
}))
